import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import {PaqueteSeguros} from '../../_models/paquete-seguros';
import {PaqueteSegurosService} from '../../_services/paquete-seguros.service';
import {AppSettingService} from '../../_services/app-setting.service';
import {Plaga} from '../../_models/plaga';
import {forkJoin} from 'rxjs';

@Component( {
  selector: 'app-paquete-seguros-editar',
  templateUrl: 'paquete-seguros-editar.component.html'
} )

export class PaqueteSegurosEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  paqSeguros: PaqueteSeguros;
  paqSegurosSe: PaqueteSeguros;
  lisPaqueteSeguros: PaqueteSeguros[] = [];
  formulario: FormGroup;
  submitted = false;
  carTabla = true;
  rangoMontoValido = true;
  rangoInvalido = false;
  tabSeleccionado = 'DATOSPRINCIPALES';

  constructor( private pagSeguroervicio: PaqueteSegurosService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private navServicio: NavService,
               public appSettingService: AppSettingService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {

        this.pagSeguroervicio.obtenerPorId( params[ 'id' ] ).subscribe( paquete => {
          this.paqSeguros = paquete;
          this.cargarInformacionInicial();
        } );
      } else {
        this.cargarInformacionInicial();
      }
    } );
  }

  cargarInformacionInicial() {

    forkJoin(
      this.pagSeguroervicio.listado()).
      subscribe( ( [ res1 ] ) => {
      this.lisPaqueteSeguros = res1;
    }, ( err1 ) => {
      this.navServicio.setMesage( 4, {
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar la información. Intente nuevamente.'
      } );
    } );

    this.formulario = this.fb.group( {
      idPaqueteSeguro: [ this.paqSeguros ? this.paqSeguros.idPaqueteSeguro : null ],
      codigo: [ this.paqSeguros ? this.paqSeguros.codigo : null, [ Validators.required ] ],
      nombre: [ this.paqSeguros ? this.paqSeguros.nombre : null, [ Validators.required ] ],
      montoMinimo: [ this.paqSeguros ? this.paqSeguros.montoMinimo : null, [ Validators.required ] ],
      montoMaximo: [ this.paqSeguros ? this.paqSeguros.montoMaximo : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.paqSeguros ? this.paqSeguros.indicadorHabilitado : true, [ Validators.required ] ],
      indicadorTradicional: [ this.paqSeguros ? this.paqSeguros.indicadorTradicional : true, [ Validators.required ] ],
      indicadorDigital: [ this.paqSeguros ? this.paqSeguros.indicadorDigital : true, [ Validators.required ] ],
    } );
    this.carInformacionInicial = false;
  }



  onSubmit() {
    this.submitted = true;
    this.rangoInvalido = this.validarRango();

    if ( !this.codExiste && this.formulario.valid && this.rangoMontoValido && this.rangoInvalido ) {
      this.guardando = true;
      const formulario = this.formulario.getRawValue();
      if(formulario.idPaqueteSeguro){
        if ( this.verificarNombre( formulario ) ) {
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.MSG_ERRORNOM' )
          } );
          this.guardando = false;
          this.submitted = false;
        } else {
          /** Actualizar  */
          this.pagSeguroervicio.actualizar( formulario ).subscribe( plaga => {
            this.paqSeguros = plaga;
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'INSUMOPECUARIO.MSG_REGACTU' )
            } );
            this.cargarInformacionInicial();
            this.cambiarTabSeleccionado( 'TABPAQUETESEGUROS' );
          } );
        }

      } else{
        if ( this.verificarCodigoYNombre( formulario ) ) {
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.MSG_ERRORCODNOM' )
          } );
          this.guardando = false;
          this.submitted = false;
        } else {
          /** Crear */
          this.pagSeguroervicio.crear( formulario ).subscribe( paquete => {
            this.paqSeguros = paquete;
            this.f.idPaqueteSeguro.setValue( this.paqSeguros.idPaqueteSeguro );
            this.f.codigo.setValue( this.paqSeguros.codigo );
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'INSUMOPECUARIO.MSG_REGGUAR' )
            } );
            this.cargarInformacionInicial();
            this.cambiarTabSeleccionado( 'TABPAQUETESEGUROS' );
          } );
        }
      }
    }
  }



  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }


  validarValor( event: any, desde: boolean ) {
    const rangoDesde = this.formulario.controls.montoMinimo.value;
    const rangoHasta = this.formulario.controls.montoMaximo.value;
    if ( desde && rangoHasta ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoMontoValido = false;
      } else {
        this.rangoMontoValido = true;
      }
    } else if ( !desde && rangoDesde ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoMontoValido = false;
      } else {
        this.rangoMontoValido = true;
      }
    }
  }

  validarCodigo() {
    this.codExiste = this.lisPaqueteSeguros.find( x => x.codigo === this.f.codigo.value ) ? true : false;
  }

  verificarNombre( item: PaqueteSeguros ): boolean {
    return (this.lisPaqueteSeguros.find( x => x.nombre === item.nombre && x.idPaqueteSeguro !== item.idPaqueteSeguro )) ? true : false;
  }

  verificarCodigoYNombre( item: PaqueteSeguros ): boolean {
    return (this.lisPaqueteSeguros.find( x => x.codigo === item.codigo || x.nombre === item.nombre )) ? true : false;
  }



  get f() {
    return this.formulario.controls;
  }

  validarRango(): boolean {
    if ( this.lisPaqueteSeguros.length === 0 ) {
      return true;
    }
    const montoMinimo = Number( this.f.montoMinimo.value );
    const montoMaximo = Number( this.f.montoMaximo.value );
    const idPaqueteSeguro = this.formulario.controls.idPaqueteSeguro.value;
    let paqueteSeguro = this.formulario.getRawValue();
    let interseccion = true;
    const dato1 = this.lisPaqueteSeguros.find( x => idPaqueteSeguro !== x.idPaqueteSeguro && x.montoMinimo <= Number( montoMinimo ) && x.montoMaximo > Number( montoMinimo ) && ((paqueteSeguro.indicadorTradicional && x.indicadorTradicional === paqueteSeguro.indicadorTradicional) || (paqueteSeguro.indicadorDigital && x.indicadorDigital === paqueteSeguro.indicadorDigital)));
    const dato2 = this.lisPaqueteSeguros.find( x => idPaqueteSeguro !== x.idPaqueteSeguro && x.montoMinimo < Number( montoMaximo ) && x.montoMaximo >= Number( montoMaximo ) && ((paqueteSeguro.indicadorTradicional && x.indicadorTradicional === paqueteSeguro.indicadorTradicional) || (paqueteSeguro.indicadorDigital && x.indicadorDigital === paqueteSeguro.indicadorDigital)));
    if ( ((dato1) || (dato2)) ) {
      interseccion = false;
    } else {
      this.lisPaqueteSeguros.map( ( s: PaqueteSeguros ) => {
        let datoMin = Number(s.montoMinimo);
        if(datoMin > montoMinimo && datoMin < montoMaximo && ( !idPaqueteSeguro || idPaqueteSeguro !== s.idPaqueteSeguro) ){
          interseccion = false;
        }
      } );
    }
    return interseccion;
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'DATOSPRINCIPALES';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'TABPAQUETESEGUROS';
        break;
      }
      default: {
        break;
      }
    }
  }

  cambiarTabSeleccionado( tab: string ) {
    this.tabSeleccionado = tab;
  }


}
